/* eslint-disabled */
export default function catchError({
  messageError,
  error,
  sendToErrorPage = false,
}) {
  try {
    if (typeof error === "object" && !sendToErrorPage && !messageError) {
      const {
        response: { data },
      } = error

      return message.error(data.data.error, 3)
    }

    if (messageError && !sendToErrorPage) {
      message.error(messageError, 3)
    }

    if (sendToErrorPage) {
      window.location.replace("/error")
    }
  } catch (error) {
    message.error("Error", 3)
  }
}

window.returnMessage = function ( // eslint-disable-line
  e,
  sendToErrorPage = false,
  callback = undefined
) {
  if (e instanceof ReferenceError) {
    return message.error(e.message, 3)
  }
  const result = e
  if (result.response) {
    var {
      response: {
        data: {
          data: { error, msj },
        },
        status,
      },
    } = e
  } else {
    var {
      data: {
        data: { msj },
      },
      status,
    } = e
  }

  switch (status) {
    case 422:
      if (typeof error === "object") {
        for (const errorx in error) {
          if (error.hasOwnProperty(errorx)) {
            error[errorx].forEach((item) => {
              message.error(item, 3)
            })
          }
        }
      } else {
        message.error(error, 3)
      }
      break
    case 201:
      if (msj) message.success(msj, 3)
      break
    case 200:
      if (msj) message.success(msj, 3)
      break
    case 202:
      if (msj) message.success(msj, 3)
      break
    case 401:
      if (error) {
        message.error(error, 3)
        location.replace("/login")
      }
      break
    case 500:
      if (error) message.error(error, 3)
      break
    case 505:
      if (error) message.error(error, 3)
      break
    case 403:
      if (error) message.error(error, 3)
      break
    case 405:
      if (error) message.error(error, 3)
      break
    case 404:
      if (sendToErrorPage) {
        history.replaceState(null, null, "/error")
      } else if (error) message.error(error, 3)
  }
  if (callback) {
    return callback()
  }
}

window.getUrlParams = function (search) { // eslint-disable-line
  if (!search) return undefined

  const hashes = search.slice(search.indexOf("?") + 1).split("&")
  const params = {}
  hashes.map((hash) => {
    const [key, val] = hash.split("=")
    params[key] = decodeURIComponent(val)
  })

  return params
}
